import styled, {css} from 'styled-components'

export const StyledTitle = styled.div`
    ${({theme: {palette, typography}}) => css`
        ${typography.textXL}
        font-weight: 500;
        color: ${palette.gray.main};
    `}
`
